import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly _count = signal(0);
  private readonly _message = signal<string | null>(null);

  public readonly isLoading = computed(() => this._count() > 0);
  public readonly message = this._message.asReadonly();

  public show(message: string | null = null): void {
    this._message.set(message);
    this._count.update((c) => c + 1);
  }

  public hide(): void {
    this._count.update((c) => Math.max(0, c - 1));
    if (this._count() === 0) this._message.set(null);
  }

  public reset(): void {
    this._count.set(0);
    this._message.set(null);
  }
}
